module.exports = __webpack_public_path__ + "img/2.b35d22f2.jpg";